import { h } from 'preact'
import { useContext, useState } from 'preact/hooks'
import cls from 'classnames'

import { FieldCommonProps } from '../../type'
import { RatingField as RatingFieldType } from 'scripts/type'
import { Svg } from 'components/ui'
import FieldsContext from '../../fieldsContext'

const starClickAnimationDuration = 500

import styles from './Compact.scss'

type Props = FieldCommonProps & {
  onSelect: (inputValue: number) => void
}

const Compact = (props: Props) => {
  const { field, onSelect } = props
  const { ratingDescriptions } = field as RatingFieldType
  const { isMultipleFields, syncFieldLabelLength } = useContext(FieldsContext)!
  const [selectedValue, setSelectedValue] = useState(-1)
  const [clicked, setClicked] = useState(false)

  const handleClick = (index: number) => {
    const isFirstClick = selectedValue === -1
    setClicked(true)
    setSelectedValue(index)
    if (isMultipleFields) {
      onSelect?.(index + 1)
      return
    }
    if (!isFirstClick) {
      onSelect?.(index + 1)
    }
    setTimeout(() => {
      isFirstClick && onSelect?.(index + 1)
      setClicked(false)
    }, starClickAnimationDuration)
  }

  return (
    <div className={styles.fieldWrapper}>
      <label
        className={styles.label}
        style={{
          width: `${syncFieldLabelLength}em`,
        }}
      >
        {field.label}
      </label>
      <div className={styles.stars}>
        {ratingDescriptions.map((_ratingDesc, index) => {
          const isSelected = selectedValue >= index
          const showClickedAnimation = clicked && selectedValue >= index

          return (
            <div key={index} className={cls(styles.starWrapper, isSelected && styles.starWrapperActive)}>
              <div className={cls(showClickedAnimation && 'pulse')} onClick={() => handleClick(index)}>
                <div data-fill="true">
                  <Svg.StarFill />
                </div>
                <div data-fill="false">
                  <Svg.StarOutline />
                </div>
              </div>
              <div className={cls(styles.descWrapper, selectedValue === index && styles.descWrapperActive)}>
                {ratingDescriptions[index]}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Compact
